module.exports = __webpack_public_path__ + "static/Pastebin-c04332b579f7bfad2a866291611efc6e.png";